module.exports = __webpack_public_path__ + "static/media/southern_charm_test_flip.6cd00ee5.avif";